import './slider.scss';

import { Button, Input, LocalizedLink } from '../primitives';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';

import blueArrow from '../../images/icons/arrow-blue.png';

export type SliderData = {
    img: IGatsbyImageData;
    title: string;
    buttons: any[];
    p: string;
    url: string;
};

export default function Slider(props: { slides: SliderData[] }) {
    const { slides } = props;

    const [sliderPosition, setSliderPosition] = useState<number>(0);
    const THREE_SECONDS_MS = 4000; //Wait 3 sec, change in the 4th

    useEffect(() => {
        const interval = setInterval(() => {
            if (sliderPosition + 1 < slides.length) {
                setSliderPosition(sliderPosition + 1);
            } else setSliderPosition(0);
        }, THREE_SECONDS_MS);

        return () => clearInterval(interval);
    }, [sliderPosition, slides.length]);

    return (
        <div className='sliderBlock'>
            <div className='slideContainer'>
                <div className='blockSliderSingle'>
                    <div className='overlay'></div>
                    <GatsbyImage
                        style={{ position: 'absolute' }}
                        loading='eager'
                        className='sliderBg'
                        image={slides[sliderPosition]?.img}
                        alt=''
                    />
                    <div className='container'>
                        <h1>{slides[sliderPosition]?.title}</h1>
                        <p className='sliderContent'>
                            {slides[sliderPosition]?.p}
                        </p>
                        {slides[sliderPosition]?.buttons.map(
                            (buttonLabel: any) => {
                                return (
                                    <LocalizedLink
                                        to={slides[sliderPosition].url}
                                        key={slides[sliderPosition].url}
                                    >
                                        <Button
                                            className='slider-btn'
                                            label={buttonLabel}
                                        />
                                    </LocalizedLink>
                                );
                            }
                        )}
                    </div>
                </div>

                <div className='sliderRadios'>
                    {slides.map((slide, index) => {
                        return (
                            <Input
                                type='radio'
                                key={index}
                                id='sliderRadio'
                                checked={sliderPosition === index}
                                onChange={() => setSliderPosition(index)}
                            />
                        );
                    })}
                </div>
                <div className='sliderArrows'>
                    <img
                        className='leftArrow'
                        src={blueArrow}
                        alt='<'
                        onClick={() => {
                            if (sliderPosition - 1 >= 0) {
                                setSliderPosition(sliderPosition - 1);
                            } else setSliderPosition(slides.length - 1);
                        }}
                    />
                    <img
                        className='rightArrow'
                        src={blueArrow}
                        alt='>'
                        onClick={() => {
                            if (sliderPosition + 1 < slides.length) {
                                setSliderPosition(sliderPosition + 1);
                            } else setSliderPosition(0);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
